'use strict';

bbw.directive.bbwPageTitle = ['$rootScope', function($rootScope) {
    return {
        restrict: 'AE',
        scope: {
            titleTemplate: '@bbwPageTitle'
        },
        link: function(scope) {
            var template = scope.titleTemplate || '{0}';
            scope.$on('bbwSetPageTitle', function(event, args) {
                var title;
                if (args.raw) {
                    title = args.title;
                } else {
                    var formatArgs = [args.title];
                    if (angular.isArray(args.args)) {
                        formatArgs.concat(args.args);
                    }
                    formatArgs.unshift(template);
                    title = ngtk.tools.string.format.apply(null, formatArgs);
                }
                document.title = title || bbw.defaultTitle;
                $rootScope.$safeApply(function() {
                    $rootScope.documentTitle = document.title;
                });
            });
        }
    };
}];
